/* sm-learn-chapter — Swiper init for the testimonial mini-carousel (3 cards desktop, 1 mobile, no loop/autoplay). */
(function () {
  'use strict';
  function initOne(carousel) {
    var swiperEl = carousel.querySelector('.sm-learn-chapter__swiper');
    if (!swiperEl || swiperEl.dataset.smInit) return;
    swiperEl.dataset.smInit = '1';
    new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      watchOverflow: true,
      breakpoints: { 750: { slidesPerView: 3, spaceBetween: 16 } },
      navigation: {
        prevEl: carousel.querySelector('.sm-learn-chapter__nav--prev'),
        nextEl: carousel.querySelector('.sm-learn-chapter__nav--next'),
        disabledClass: 'is-disabled'
      },
      a11y: { enabled: true }
    });
  }
  function initAll() {
    document.querySelectorAll('.sm-learn-chapter__carousel').forEach(initOne);
  }
  function whenSwiper(cb, tries) {
    if (window.Swiper) return cb();
    if ((tries || 0) > 100) return;
    setTimeout(function () { whenSwiper(cb, (tries || 0) + 1); }, 100);
  }
  function boot() { whenSwiper(initAll); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
